<template>
    <section
            class="pf-pagination"
            :class="align == 'right' ? 'pagination-right' : ''"
    >
        <el-pagination
                :layout="layout"
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                @prev-click="handlePreClick"
                @next-click="handleNextClick"
                :page-sizes="[5, 10, 15, 20, 30, 40, 50, 100]"
                :page-size="data.pageSize"
                :current-page="data.pageNum"
                :total="data.total"
        ></el-pagination><el-button type="primary" @click="" size="small">确定</el-button>
    </section>
</template>
<script>
export default {
  name: 'pagination',
  props: {
    data: {
      type: Object,
      default: () => ({ pageSize: 10, pageNum: 1, total: 0 })
    },
    layout: { type: String, default: 'total,sizes ,prev, pager, next,jumper' },
    align: { type: String, default: 'center' }
  },
  data() {
    return {}
  },
  mounted() {
    this.$nextTick(() => {})
  },
  watch: {},
  methods: {
    // 上一页触发
    handlePreClick() {
      this.data.pageNum--
      this.$emit('refresh', { pagination: this.data })
    },
    // 下一页触发
    handleNextClick() {
      this.data.pageNum++
      this.$emit('refresh', { pagination: this.data })
    },
    // currentPage 改变时会触发
    handleCurrentChange(data) {
      if (this.data.pageNum == data) return
      this.data.pageNum = data
      this.$emit('refresh', { pagination: this.data })
    },
    // pageSize 改变时会触发
    handleSizeChange(data) {
      if (this.data.pageSize == data) return
      this.data.pageNum = 1
      this.data.pageSize = data
      this.$emit('refresh', { pagination: this.data })
    }
  }
}
</script>
<style scoped>
    .pf-pagination {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .pf-pagination.pagination-right .el-pagination {
        justify-content: flex-end !important;
        text-align: right;
    }
    .pf-pagination .el-pagination.is-background .btn-next,
    .pf-pagination .el-pagination.is-background .btn-prev,
    .pf-pagination .el-pagination.is-background .el-pager li {
        background: none;
        font-weight: normal;
    }
    .pf-pagination .el-pager li {
        font-weight: normal;
    }
    .pf-pagination .el-pagination__sizes .el-input .el-input__inner {
        font-size: 14px;
    }
    .pf-pagination .el-pagination button,
    .pf-pagination .el-pagination span:not([class*="suffix"]) {
        font-size: 14px;
    }
    .pf-pagination .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #2789EE;
    }
</style>
